import React from 'react';
import PropTypes from 'prop-types';

const Select = ({ select, refs, onChange, optionList, defaultValue, name, cssClass, empty }) => (
  <React.Fragment>
    <select
      ref={r => refs.store('select', r)}
      className={`selectvalue ${cssClass || ''}`}
      onChange={event => onChange(event)}
      defaultValue={defaultValue}
      name={name}
    >
      {typeof empty !== 'undefined' && (<option value="">{empty}</option>)}
      {!Array.isArray(optionList) && Object.keys(optionList).map(value => (
        <option value={value} key={value}>{optionList[value]}</option>
        ))}
      {Array.isArray(optionList) && optionList.map(option => (
        <option value={option.value} key={option.value}>{option.label}</option>
      ))}
    </select>
  </React.Fragment>
);

Select.propTypes = {
  onChange: PropTypes.func,
  // optionList: PropTypes.object.isRequired,
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/form/niceSelect/Select.jsx